"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventSchema = exports.ContextSchema = exports.defaultSnowplowActivityTrackingConfig = void 0;
exports.defaultSnowplowActivityTrackingConfig = {
    minimumVisitLength: 15,
    heartbeatDelay: 15,
};
var ContextSchema;
(function (ContextSchema) {
    ContextSchema["CareResource"] = "iglu:com.buoyhealth/care-resource/jsonschema/1-0-0";
})(ContextSchema = exports.ContextSchema || (exports.ContextSchema = {}));
var EventSchema;
(function (EventSchema) {
    EventSchema["CareResourceImpression"] = "iglu:com.buoyhealth.care-resources/care-resource-impression/jsonschema/1-0-0";
    EventSchema["ExperimentationExposure"] = "iglu:com.buoyhealth/ab-test-assignment/jsonschema/1-0-0";
})(EventSchema = exports.EventSchema || (exports.EventSchema = {}));
//# sourceMappingURL=constants.js.map